import { redirectToPage } from 'app/common/redirects/Redirects';
import CustomerSummary from 'app/settings/organization/customers/customer-summary/CustomerSummary';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const CustomerSummaryForModule = ({moduleName=null, redirectUrl=null}) => {
    const history=useNavigate();

    const redirect=()=>{
        redirectToPage(history,redirectUrl);
    }

    if(!redirectUrl || !moduleName)
        return null;

    return (
        <div style={{margin:"0.8rem"}}>
            <CustomerSummary 
                module={moduleName}
                redirect={redirect}
            />
        </div>
    )
}

export default CustomerSummaryForModule